<div class="site-list-flex-wrapper" (keydown)="onKeyDown($event)"
  (drop)="dropOnViewWhiteSpace($event)"
  (dragover)="allowDrop($event)">
  @for (item of this.FilteredList; track item) {
    <div
      class="tile"
      [ngClass]="{selected: item['id'] === selectedItemId }"
      [class.show-tile-border]="!this.ItemIsBeingDraggedBase"
      (click)="onEditClick($event, item); this.rowClicked(item)"
      (contextmenu)="onItemContextMenu($event, item, this.selectedItems(this.Selection)); this.onRightClick(item)"
      title="{{this.getItemTitle(item)}}"
      tabindex="0"
      (keyup.enter)="onEditClick($event, item)"
      droppable
      [dropScope]="'item'"
      (onDrop)="this.onDragDrop($event,item)"
      [class.FormInstance]="this.isTypeFormInstance(item)"
      [class.Attachment]="this.isTypeAttachment(item)"
      (drop)="this.dropGridOrTileObject($event, item)"
      (dragover)="allowDrop($event)">
      <div class="tile-container">
        <div class="tile-icon-actionbuttons">
          <div class="tile-top">
            <mat-checkbox (click)="$event.stopPropagation(); this.setSelectedItem($event, item)"
              (change)="$event ? this.Selection.toggle(item) : null"
              [checked]="this.Selection.isSelected(item)"
              [ngClass]="{'selected-show': this.Selection.isSelected(item)}"
              class="single-action-button checkbox-action-button rounded-checkbox">
            </mat-checkbox>
            <div class="action-buttons">
              @for (btn of itemActionButtons; track btn) {
                <div class="single-action-button">
                  @if (btn.appliesTo(item)) {
                    @if (btn.iconFormatFor(item) == 'MatIcon') {
                      <mat-icon
                        [ngClass]="{selected:generateItemActionId(item, btn) === selectedItemActionId}"
                        title="{{getActionButtonTitle(btn, item)}}"
                        fontSet="material-icons-outlined"
                        class="action-icon"
                        [class]="this.HideActionButtonsClass"
                        tabindex="0"
                        (click)="onItemActionClick($event, item, btn)"
                        (keyup.enter)="onItemActionClick($event, item, btn)">
                        {{btn.iconFor(item)}}
                      </mat-icon>
                    }
                    @if (btn.iconFormatFor(item) == 'SvgIcon') {
                      <mat-icon
                        svgIcon="{{btn.iconFor(item)}}"
                        class="action-icon mat-icon-svg"
                        [class]="this.HideActionButtonsClass"
                        [ngClass]="{selected:generateItemActionId(item, btn) === selectedItemActionId}"
                        title="{{getActionButtonTitle(btn, item)}}"
                        fontSet="material-icons-outlined"
                        tabindex="0"
                        (click)="onItemActionClick($event, item, btn)"
                        (keyup.enter)="onItemActionClick($event, item, btn)">
                      </mat-icon>
                    }
                  }
                </div>
              }
            </div>
          </div>
          <div class="tile-icon-container">
            @if (item.getIconType() == 'SvgIcon') {
              <!--
              <i *ngIf="!item.canBeDeleted()"
                [appIcon] svgIcon="{{item.getIcon()}}" appIconItemType="svgIcon"
              class="tile-icon"></i>
              <i *ngIf="item.canBeDeleted()"
                [appIcon] svgIcon="{{item.getIcon()}}" appIconItemType="svgIcon"
              class="tile-icon"></i>
              -->
              @if (!item.canBeDeleted()) {
                <mat-icon
                  svgIcon="{{item.getIcon()}}"
                class="tile-icon svg-tile-icon"></mat-icon>
              }
              @if (item.canBeDeleted()) {
                <mat-icon
                  svgIcon="{{item.getIcon()}}"
                  class="tile-icon svg-tile-icon"
                  draggable
                  [dragScope]="'item'"
                  [dragData]="item"
                  (onDragStart)="this.TileItemDragged(item); this.onItemDragStart($event, this.selectedItems(this.Selection, item))"
                  (onDragEnd)="this.onItemDragEnd($event, this.selectedItems(this.Selection, item))"
                  [class.FormInstance]="this.isTypeFormInstance(item)"
                [class.Attachment]="this.isTypeAttachment(item)"></mat-icon>
              }
            }
            @if (item.getIconType() != 'SvgIcon') {
              @if (!item.canBeDeleted()) {
                <mat-icon
                  class="tile-icon"
                [appIcon]="item"></mat-icon>
              }
              @if (item.canBeDeleted()) {
                <mat-icon
                  class="tile-icon"
                  [appIcon]="item"
                  draggable
                  [dragScope]="'item'"
                  [dragData]="item"
                  (onDragStart)="this.TileItemDragged(item); this.onItemDragStart($event, this.selectedItems(this.Selection, item))"
                  (onDragEnd)="this.onItemDragEnd($event, this.selectedItems(this.Selection, item))"
                  [class.FormInstance]="this.isTypeFormInstance(item)"
                [class.Attachment]="this.isTypeAttachment(item)"></mat-icon>
              }
            }
          </div>
        </div>
        <div class="tile-namePlate">
          <div class="tile-name">{{ item.name }}</div>
          <div class="tile-subText">{{ item.modifiedDate | date: 'MMMM d, yyyy' }}</div>
        </div>
      </div>
    </div>
  }
</div>
